export default {
  message: {
    loginTitle: '盛事会展',
    loginDesc:'在线申报平台',
    loginWays:['电脑登录'],
    registerUser:"输入手机号",
    loginUser:'输入手机号或邮箱',
    loginPass:'登录密码',
    loginBtn:'登录',
    loginManual:'操作手册',
    loginAbout:'关于盛事',
    forgetPass:'忘记密码',
    register:'立即注册',
    enterCode:'短信验证码',
    getCode:'获取验证码',
    getCodeAgain:'60秒后可重发',
    fillCompanyName:'输入公司名称',
    registerBtn:'注册',
    login:'立即登录',
    createPass:'创建登录密码',
    surePass:'确认登录密码',
    changePass:'确认修改',
    scan:'使用微信扫描二维码',
    // 展会列表
    enterExhibition:'进入展会',
    timeOver:'距离展会开幕：',
    days:'天',
    // 首页
    Unfold:'展开',
    Fold:'收起',
    StatusDrawingReview:'审图状态',
    currentExhibition:'点击进入展会首页',
    // currentExhibition:'当前展会',
    homePage:'首页',
    switchExhibition:'切换展会',
    me:'我的后台',
    logout:'退出登录',
    addBooth:'添加展位',
    aboutExhibition:'展会介绍',
    relevantDocuments:'相关资料',
    No:'序号',
    documentName:'文件名称',
    documentSize:'文件大小',
    operation:'操作',
    download:'下载',
    myBooth:'我的展位',
    boothNo:'展位号',
    exhibitorName:'展商名称',
    pubdate:'录入时间',
    boothType:'展位类型',
    fasciaBoard:'楣板',
    rental:'租赁',
    upgrades:'定制服务',
    check:'查看',
    notice:'系统通知',
    edit:'编辑',
    drawings:'报图',
    more:'更多',
    // 添加展位
    shellScheme :'标摊',
    rawSpace:'特装',
    biaoRawSpace:'标改特',
    hall:'展馆号',
    exhibitionImage:'标摊类型',
    select:"选择",
    enter:'输入',
    boothArea:'展位面积',
    openSide:'开口数量',
    contactPerson:'展商联系人',
    contactTel:'展商联系电话',
    contactEmail:'展商邮箱',
    confirm:'确认',
    editBotth:'编辑展位',
    addBoothWarn:'60个字节以内',
    doubleLayerArea:'双层面积',
    ConstructorName:'搭建公司',
    ContactPerson:'搭建负责人',
    ConstructorTel:'搭建商联系电话',
    ConstructorEmail:'搭建商邮箱',




    // 添加楣板
    cnFasciBoard:'中文楣板',
    enFasciBoard:'英文楣板',
    boothDesignPicture:'展位效果图',
    furnitureConfiguration:'家具配置图',
    upLoadFile:'上传文件',
    hasUpload:'已上传',
    fasciBoardWarn:'仅作为示例，不代表实际效果',
    lookFasciBoard:'查看楣板',
    addFasciBoard:'添加楣板',

    // 租赁
    equipmentRental:'展馆设施',
    furnitureRental:'家具租赁',
    otherService:'其他服务',
    addSchedule:'选择预定',
    addScheduleDesc:'所有租赁服务预定完成后，请点击购物车进行结算',
    cart:'购物车',
    cartTip: '选购完成后请点击 “购物车” 按钮下单',
    // 定制服务
    shellSchemeUpgrades:'标摊升级',
    shellSchemePosterDecoration:'标摊美化',
    // 物品详情
    itemSpecific:"物品详情",
    rentalPeriod:'租赁周期',
    specification:'规格',
    quantity:'数量',
    remark:'备注',
    deposit:'押金',
    rentalPrice:'租金',
    // 购物车
    item:'商品',
    unitPrice:'单价(元)',
    depositRMB:'押金(元)',
    delete:'删除',
    selectAll:'全选',
    total:'合计',
    includingRentalDeposit:'其中租赁押金',
    toPay:'去结算',
    orderConfirmation:'订单确认',
    paymentAmount:'支付金额',
   orderConfirmBtn:'确认订单',
   orderConfirmWarn:'订单通过管理人员审核后，在“我的展位”里一并付款',
   goToOrder:'订单已生成，是否前往查看？',
   viewOrder:'查看订单',
   toHome:'返回首页',
   // 个人中心 - 基本信息
   generalInformation:'基本信息',
   // myBooth:'我的展位',
   complianceNotices:'违规通知',
   supplementaryInformation:'补资料',
   account:'账号',
   companyName:'公司名称',
   accountType:'用户类型',
   exhibitor:'展商',
   businessAddress:'公司地址',
   accountContactPerson:'联系人',
   title:'职务',
   email:'邮箱',
   tel:'手机号',
   save:'保存',
   // 我的展位
  exhibitionName:'展会名称',
  paymentReminder:'付款提醒',
  totalAmount:'总金额(含押金)',
  depositReceipt:'下载押金单',
  invoice:'开发票',
  depositRefund:'退押金',
  buyItem:'采购条目',
  amount:'金额',
  orderTime:'下单时间',
  status:'状态',
  viewInvoice:'查看付款通知书',
  uploadPaymentVoucher:'上传凭证',
  cancelOrder:'取消订单',
  paySuccessWarn:'付款凭证上传成功，请等待管理员审核',
  ok:'我知道了',
  boothSearch:'输入展会名称、展位号搜索',
  unpaidWarn:'待付款',
  paidWarn:'无',
  // 违规信息
  violationInformation:'违规信息',
  fileName:'资料名称',
  fileStatus:'文件状态',
  uploadTime:'上传时间',
  upload:'上传',
  reminder:'提示',
  infoUploadSuccess:'资料上传成功，请等待管理员审核',
  cancel:'取消',
  // 退押金
  deduction:'扣除押金',
  photo:'图片',
  depositRefundWarn:'请上传押金凭证，管理员审核成功后30个工作日内押金会退还至您的账户',
  cancelOrderWarn:' 是否确认取消订单？',
  yes:'是',
  not:'否',
  // 报图
  uploadFile2:'上传资料',
  length:'长度',
  width:'宽度',
  area:'面积',
  extraHigh:'超高',
  haningPoint:'吊点',
  doubleLayer:'双层',
  ceiling:'封顶',
  ceilingArea:'封顶面积',
  reviewComments:'审核意见',
  approver:"审批人",
  reviewDate:'审批时间',
  SingleImageLimited:'单张图片限制2M以内',
  Approved:'审核通过',
  Pending:'待审核',
  close:'关闭',
  Search:'搜索',
  ApplicationRefund:'申请退款',
  Approval:'审核',
  Failed:'审核失败',
  Submit:'确认提交',
  Upload2:'确认上传',
  reUpload:'重新上传资料',
  pictureUploadWarn:"请一次性上传,最多可上传10张图片(可按住Ctrl键多选)！如遇点击“上传功能”按钮无反应，请更换其它浏览器（推荐谷歌浏览器）! 支持jpg,png,bmp,jpeg格式文件",
  refundReason:'输入退款理由',
  checkReason :'查看原因',
  BoothHeight:'展台高度',
  // 开发票
  invoicedAmount:'开票总金额',
  applicationInvoicedAmount:'申请开票金额',
  pickupMethod:'领取方式',
  receivedScene:'现场领取',
  sfFreight:'展后邮寄(顺丰到付)',
  typeInvoice:'开票类型',
  FreeInvoice:'全电发票-增值税普通发票',
  VATInvoice:'全电发票-增值税专用发票',
  InvoiceTitle:'发票抬头',
  TaxpayerRegistrationNumber:'纳税人识别号',
  BankName:'开户行',
  BankAccount:'银行账户',
  RegisteredAddress:'注册地址',
  Telephone:'电话',
  Remarks:"备注信息",
  ApplicationDate:'申请时间',
  RejectReason:'拒绝原因',
  Addressee:'收件人',
  AddresseeTelephone:'收件人电话',
  MailingAddress:'邮寄地址',
  invoiceSubmit:'提交申请',
  UploadAttachments:'上传附件',
  InvoiceInformation:'开票信息',
  notUploaded:'未上传',
  uploadReminder: '提示：请及时上传付款凭证（含押金）。确认全部款项到账后，系统开放审核权限。'

  }
}



// WEBPACK FOOTER //
// ./src/assets/language/language-CN.js